import useTheme from "@/src/common/hooks/useTheme"
import FMDQTable from "@/src/sb/components/FMDQTable"
import useFxRates from "@/src/sb/hooks/useFXRates"
import { format, isValid, parse } from "date-fns"
import React from "react"

export const columns = [
  { key: "date", label: "Date" },
  { key: "nafem_usd", label: "FMDQ FX(USD:NGN)", defaultChecked: false },
  { key: "nafem_usd_percent_change", label: "% CHG", defaultChecked: false },
  { key: "nafex_usd", label: "NAFEX(USD:NGN)", defaultChecked: false },
  { key: "nafex_usd_percent_change", label: "% CHG", defaultChecked: false },
  { key: "cbn_usd", label: "CBN NFEM(USD:NGN)" },
  { key: "cbn_usd_percent_change", label: "% CHG" },
  { key: "cbn_pounds", label: "CBN(GPB:NGN)" },
  { key: "cbn_pounds_percent_change", label: "% CHG" },
  { key: "cbn_euro", label: "CBN(EUR:NGN)" },
  { key: "cbn_euro_percent_change", label: "% CHG" },
  { key: "parallel_usd", label: "Parallel(USD:NGN)" },
  { key: "parallel_usd_percent_change", label: "% CHG" },
  { key: "parallel_pounds", label: "Parallel(GBP:NGN)" },
  { key: "parallel_pounds_percent_change", label: "% CHG" },
  { key: "parallel_euro", label: "Parallel(EUR:NGN)" },
  { key: "parallel_euro_percent_change", label: "% CHG" }
]

type FxRateRow = {
  date: string
  [key: string]: any
}

export const FMDQEMBED = () => {
  const { fxRates, loading } = useFxRates()
  const { theme } = useTheme()

  const formatDates = (fxRates: FxRateRow[]) => {
    return fxRates?.map((row) => {
      const parsedDate = parse(row.date, "MMM d yyyy", new Date())
      const formattedDate = isValid(parsedDate)
        ? format(parsedDate, "MMM d, yyyy")
        : "Invalid Date"
      return {
        ...row,
        date: formattedDate,
        parsedDate: isValid(parsedDate) ? parsedDate : null
      }
    })
  }
  const formattedFxRates = formatDates(fxRates)

  return (
    <div className={theme}>
      <FMDQTable columns={columns} rows={formattedFxRates} loading={loading} />
    </div>
  )
}

export default FMDQEMBED
